<script>
export default {
    name: 'design-2021-help-contact-info-component',
};
</script>

<template>
    <div class="contact-info-wrapper">
        <div class="contact-info">
            <h4 class="title">{{ $t('help.contact_details') }}</h4>
            <div class="notice-text">
                <p>{{ $t('help.do_you_have_a_question_or_comment') }}</p>
                <p>
                    {{ $t('help.contact_us_via_the_contact_form_or_send_an_email') }}
                    <a href="mailto:info@apprenticexm.nl">info@apprenticexm.nl</a>
                </p>
            </div>
            <div class="phone">
                <div class="icon">
                    <i class="fas fa-phone-alt icon"></i>
                </div>

                <div class="description">
                    <p>
                        {{ $t('help.you_can_reach_us_by_telephone_from_monday_to_thursday_between_9_am_and_5_pm') }}
                    </p>
                    <p>{{ $t('help.on_fridays_we_are_available_between_9_am_and_3_pm') }}</p>

                    <a
                        class="phone-number"
                        href="tel:0263647300">
                        +31 (0)26 361 7300
                    </a>
                </div>
            </div>
        </div>

        <address class="address">
            <div class="icon">
                <i class="fas fa-address-card icon"></i>
            </div>
            <div class="description">
                <p class="street-name">Velperweg 80</p>
                <span class="zip-code">6824HL</span>
                <span class="city">Arnhem</span>
            </div>
        </address>
    </div>
</template>

<style scoped lang="scss">
.contact-info-wrapper {
    display: flex;
    flex-direction: column;
    background-color: $primary;
    color: $white;
    padding: $grid-gutter-width;
    margin-bottom: 0;
}

.notice-text {
    margin-bottom: $grid-gutter-width;

    p {
        margin-bottom: 0;
    }

    a {
        color: $primary-background-color;
    }
}

.phone,
.address {
    display: flex;
    gap: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    font-size: $base-font-size;

    .icon {
        width: 30px;
        text-align: center;
        font-size: 1.3125rem;
        color: $primary-background-color;
        filter: contrast(0.7);
    }

    .description {
        flex: 1 0;
        margin-bottom: 0;

        p {
            margin-bottom: 0;
        }
    }
}

.phone {
    a {
        color: $primary-background-color;
        line-height: 2;
    }
}

.address {
    p {
        margin-bottom: 0;
    }
}
</style>
